import React from "react";
import {
  CheckIcon,
  CollectionIcon,
  HomeIcon,
  HeartIcon,
} from "@heroicons/react/solid";

import Logo from "../components/ui/Logo";
import SidebarLink from "./SidebarLink";

interface SidebarProps {
  col: string;
}

const Sidebar: React.FC<SidebarProps> = ({ col }) => {
  return (
    <aside
      className={`sticky top-0 z-50 secondary-bg border-r primary-border-color h-screen overflow-y-hidden ${col}`}>
      <div className="container primary-py flex flex-col items-center md:items-start gap-8">
        <Logo />
        <SidebarLink Icon={HomeIcon} to="/" label="home" />
        <SidebarLink Icon={HeartIcon} to="/favourite" label="favourite" />
        <SidebarLink
          Icon={CollectionIcon}
          to="/in-progress"
          label="in progress"
        />
        <SidebarLink Icon={CheckIcon} to="/completed" label="completed" />
      </div>
    </aside>
  );
};

export default Sidebar;
